export const contactData = {
  title: "Contact Us",
  contactInfo: {
    phone: "+91 8484046484",
    email: "satyanamsolar@gmail.com",
    address: "Plot no 32, Bandu Soni Layout, IT park, Nagpur",
  },
  socialMedia: [
    {
      icon: "Instagram",
      link: "https://www.instagram.com/satyanamsolar?igsh=MXR0aTV3ODRkOXliOA==",
    },
    {
      icon: "Facebook",
      link: "https://www.facebook.com/share/1BoQkbEcF4/?mibextid=wwXIfr",
    },
    {
      icon: "LinkedIn",
      link: "https://www.linkedin.com/company/satyanam-solar-llp/",
    },
  ],
};